import axios, { AxiosInstance } from 'axios';
import { vxm } from '@/stores';
import router from '@/router';

export function parseHttpRequestError(error: any): string {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);

    return error.response.status +  " error: " + error.message + " - " + JSON.stringify(error.response.data);
  }
  else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    return "A request was made but no response was received from the server";
  }
  else {
    // Something happened in setting up the request that triggered an Error
    return error.message;
  }
}

type ResponseType = 'text' | 'arraybuffer' | 'blob' | 'document' | 'json' | 'stream' | undefined | null;

interface HttpRequestOptions {
  includeAuthorization?: boolean;
  responseType?: ResponseType;
}

export function createHttpRequest(options: HttpRequestOptions = {}): Promise<AxiosInstance> {
  return new Promise<AxiosInstance>(async (resolve, reject): Promise<any> => {
    let request: any = {
      baseURL: process.env.VUE_APP_API_URI,
      headers: {

      }
    };

    if(options.includeAuthorization !== false){
      request.headers.Authorization = "Bearer " + vxm.auth.jwt;
    }

    if(options.responseType != null){
      request.responseType = options.responseType;
    } else {
      request.responseType = 'text';
    }

    try {
      const client = axios.create(request);

      client.interceptors.response.use(undefined, (error): Promise<never> => {
        if(error && error.response && (error.response.status == 401 || error.response.status == 403)){
          router.push({ name: 'logout' });
          return;
        }

        return Promise.reject(parseHttpRequestError(error));
      })

      resolve(client);
    } catch (e) {
      // eslint-disable-next-line
      console.log(e);
      reject(e);
    }
  });
}
